const unitOfTime = [
    {
        'key': 'second',
        'value': 'seconds',
        seconds: true,
    },
    {
        'key': 'minute',
        'value': 'minutes',
        minutes: true,
    },
    {
        'key': 'hour',
        'value': 'hrs',
        hours: true,
    },
    {
        'key': 'day',
        'value': 'days',
        days: true,
    },
    {
        'key': 'week',
        'value': 'weeks',
        weeks: true,
    },
    {
        'key': 'month',
        'value': 'months',
        days: true,
    },
    {
        'key': 'year',
        'value': 'years',
        years: true,
    },
  ];

  module.exports = {
    unitOfTime
  }; 